export default __webpack_public_path__ + "static/media/Apple (5).4883bb53.jpg";